import { api, endpoints } from "api/api";
import { BaseApiPaging } from "api/types";
import { AxiosPromise } from "axios";
import { BlockUserFormValues } from "components/templates/BlockUserModal/BlockUserModal";
import { NotesFormValues } from "components/templates/UserNoteModal/UserNoteModal";
import { UserFormValues } from "pages/Students/UserForm/UserForm";

const fetch = (skip: number, take: number, searchPhrase: string): AxiosPromise<BaseApiPaging<StudentApi>> => {
  return api.get<BaseApiPaging<StudentApi>>(endpoints.STUDENTS.GET(skip, take, searchPhrase));
};

const fetchById = (studentId: number): AxiosPromise<StudentApi> => {
  return api.get<StudentApi>(endpoints.STUDENTS.GET_BY_ID(studentId));
};

const create = (data: UserFormValues): AxiosPromise => {
  const { licencePhoto, ...request } = data;
  const formData = new FormData();

  if (licencePhoto && typeof licencePhoto !== "string") formData.append("licencePhoto", licencePhoto as File);

  Object.entries(request).map(([key, value]) => {
    if (value instanceof Date) value = value.toISOString();
    //@ts-ignore
    formData.append(key, value);
  });

  return api.post(endpoints.ADMIN_USERS.CREATE, formData);
};

const update = (studentId: number, data: UserFormValues): AxiosPromise => {
  const { licencePhoto, ...request } = data;
  const formData = new FormData();

  if (licencePhoto && typeof licencePhoto !== "string") formData.append("licencePhoto", licencePhoto as File);

  Object.entries(request).map(([key, value]) => {
    if (!value) return;
    // if value is Date type convert to iso string
    if (value instanceof Date) value = value.toISOString();
    //@ts-ignore
    formData.append(key, value);
  });

  return api.put(endpoints.STUDENTS.UPDATE(studentId), formData);
};

const block = (studentId: number, data: BlockUserFormValues): AxiosPromise => {
  return api.put(endpoints.STUDENTS.BLOCK(studentId), data);
};

const deleteUser = (studentId: number): AxiosPromise => {
  return api.delete(endpoints.STUDENTS.DELETE(studentId));
};

const createNote = (studentId: number, data: NotesFormValues): AxiosPromise => {
  return api.post(endpoints.STUDENTS.CREATE_NOTE(studentId), data);
};

const getNotes = (studentId: number): AxiosPromise<StudentNotesApi[]> => {
  return api.get<StudentNotesApi[]>(endpoints.STUDENTS.GET_NOTES(studentId));
};

const updateNote = (studentId: number, noteId: number, data: NotesFormValues): AxiosPromise => {
  return api.put(endpoints.STUDENTS.UPDATE_NOTE(studentId, noteId), data);
};

const deleteNote = (studentId: number, noteId: number): AxiosPromise => {
  return api.delete(endpoints.STUDENTS.DELETE_NOTE(studentId, noteId));
};

const changeEmail = (studentId: number, data: { email: string; message?: string }): AxiosPromise => {
  return api.put(endpoints.STUDENTS.CHANGE_EMAIL(studentId), data);
};

export const studentsApi = {
  fetch,
  fetchById,
  create,
  update,
  block,
  delete: deleteUser,
  createNote,
  getNotes,
  updateNote,
  deleteNote,
  changeEmail,
};

export interface StudentApi {
  address: string;
  bornDate?: Date;
  bornPlace?: string;
  buyer: string;
  buyerAddress: string;
  buyerNIP: string;
  createdDate: Date;
  email: string;
  firstName: string;
  id: number;
  licencePhoto: string;
  pesel: string;
  phone: string;
  roles: Role[];
  surname: string;
}

export interface Role {
  id: number;
  name: string;
}
export interface StudentNotesApi {
  id: number;
  notes: string;
  userId: number;
  createdDate: Date;
  author: {
    email: string;
    firstName: string;
    id: number;
    surname: string;
  };
}
